import styled from 'styled-components';

const CampaignWrapper = styled.div`
    background-color: rgba(6, 142, 249, 0.1);
    border-radius: 8px;
    color: #068EF9;
    padding: 16px;
`;

const TitleWrapper = styled.div`
    display: flex;
    padding-bottom: 16px;
    & > h2 {
        padding-left: 16px;
    }
`;

export {
    CampaignWrapper,
    TitleWrapper,
};
